import axios from 'axios';
import config from 'config';

const {
  cognitiveLayer: {
    api: { dev: devUrl },
    endpoints: { aiWorkspace  : { upload } },
  },
} = config;

export const uploadCsvToAiWorkspace = (csvText, workspaceId, onUploadProgress) => {
  if (!workspaceId) {
    const error = new Error('Workspace ID is required');
    error.code = 'WORKSPACE_ID_REQUIRED';
    throw error;
  }

  const uploadUrl = upload.replace('{workspaceId}', workspaceId);
  const userId = process.env.REACT_APP_AI_USER_ID || 'test-user';
  const claims = btoa(JSON.stringify({ sub: userId }));

  return axios.post(
    `${devUrl}${uploadUrl}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
    {
      name: 'jobs_csv',
      why: 'jobs scenario',
      text: csvText,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Claims': claims,
      },
      onUploadProgress,
    },
  );
};
